import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import "../Forms/css/register.css";

const token = localStorage.getItem('authToken');

class AddProductCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryName: '',
            description: '',
          
            images: [],
            submissionStatus: null,
            
        };
    }


   

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleFileChange = (e) => {
        const { name, files } = e.target;
        this.setState({ [name]: files }); // Store all selected files
    };

   

    handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
    
        // Filter out unnecessary fields and append only needed fields
        const fieldsToSubmit = ['categoryName', 'description', 'images'];
        fieldsToSubmit.forEach(key => {
            if (key === 'images') {
                // Append each image to FormData
                Array.from(this.state.images).forEach(file => {
                    formData.append('images', file);
                });
            }else {
                formData.append(key, this.state[key]);
            }
        });
    
        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            };
    
            const response = await axios.post("https://brand.aasmo.in/api/admin/add-category", formData, config);
    
            if (response && response.status === 201) {
                this.setState({ submissionStatus: 'success' });
                setTimeout(() => {
                    window.location.href = "/list-product-category";
                }, 2000);
            } else {
                console.log('Unexpected response:', response);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            if (error.response) {
                const { status, data } = error.response;
                if (status === 400) {
                    console.error('Bad request error:', data);
                } else if (status === 401) {
                    console.error('Unauthorized error, please log in again.');
                } else {
                    console.error('Error response:', error.response);
                }
            } else {
                console.error('Network or other error:', error);
            }
        }
    };
    

    render() {
        const { submissionStatus } = this.state;

        return (
            <div className="col-md-12">
                <form onSubmit={this.handleSubmit}>
                    <div className="card">
                        <div className="header">
                            <h2>Add Product Category</h2>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Category Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="categoryName"
                                            value={this.state.categoryName}
                                            onChange={this.handleChange}
                                            placeholder="Category Name"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea
                                            className="form-control"
                                            name="description"
                                            value={this.state.description}
                                            onChange={this.handleChange}
                                            placeholder="Description"
                                        />
                                    </div>
{/* 
                                    <div className="form-group">
                                        <label>Store</label>
                                        <select
                                            className="form-control"
                                            name="selectedBrand"
                                            value={this.state.selectedBrand}
                                            onChange={this.handleBrandChange}
                                        >
                                            <option value="">Select a Store</option>
                                            {brands.map(brand => (
                                                <option key={brand._id} value={brand._id}>
                                                   
                                                    {brand.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div> */}

                                    <div className="form-group">
                                        <label>Images</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="images"
                                            onChange={this.handleFileChange}
                                            multiple // Allow multiple files
                                        />
                                        <div className="col-md-6">
                                            {this.state.images.length > 0 && (
                                                <div className="mt-2">
                                                    {Array.from(this.state.images).map((file, index) => (
                                                        <img
                                                            key={index}
                                                            src={URL.createObjectURL(file)}
                                                            alt={`Deliveryman ${index}`}
                                                            className="img-thumbnail mt-2"
                                                            style={{ width: '100px', height: '100px' }}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {submissionStatus === 'success' && (
                                        <div className="alert alert-success" role="alert">
                                            Form submitted successfully!
                                        </div>
                                    )}

                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(AddProductCategory);
